import React from "react";
import styles from "./site-footer.module.scss";
import iconFacebook from "../images/social-facebook.svg";
import iconInstagram from "../images/social-instagram.svg";
import iconLinkedIn from "../images/social-linkedin.svg";
import iconYouTube from "../images/social-youtube.svg";
import iconX from "../images/social-x.svg";

export default function SiteFooter() {
  return (
    <section className={styles.footer}>
      <div className={`contentContainer ${styles.container}`}>
        <ul className={styles.secondaryLinks}>
          <li>
            <a href="/contact">Contact us</a>
          </li>
          <li>
            <a href="/privacy">Privacy policy</a>
          </li>
          <li>
            <a href="https://stories.bringthemhomenow.net/" target="_blank">
              BringThemHomeNow
            </a>
          </li>
        </ul>
        <ul className={styles.socialLinks}>
          <li>
            <a href="https://www.facebook.com/Run4TheirLives" target="_blank">
              <img src={iconFacebook} />
            </a>
          </li>
          <li>
            <a href="https://twitter.com/Run4lives2023" target="_blank">
              <img src={iconX} />
            </a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/werun4theirlives/"
              target="_blank"
            >
              <img src={iconInstagram} />
            </a>
          </li>
          <li>
            <a href="https://www.youtube.com/@Run4TheirLives" target="_blank">
              <img src={iconYouTube} />
            </a>
          </li>
          <li>
            <a
              href="https://www.linkedin.com/company/run4theirlives/"
              target="_blank"
            >
              <img src={iconLinkedIn} />
            </a>
          </li>
        </ul>
      </div>
    </section>
  );
}
